export const OBJECTION_MODAL_STAGE = {
  INITIAL: 'initial',
}
